// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';

import { S } from './styles';

export type TabType = 1 | 2 | 3 | 4;

export interface TabContentProps {
  value: TabType;
  title: string;
}

export interface TabProps {
  list: Array<TabContentProps>;
  defaultValue: number;
  onClick: (value: TabType) => void;
}

const Tabs = (props: TabProps) => {
  const Splitter = ({ index, value }: { index: number; value: number }) => {
    if (
      index !== props.list.length - 1 &&
      props.defaultValue !== value &&
      props.defaultValue - 1 !== value
    ) {
      return (
        <span
          style={{
            position: 'absolute',
            right: '0px',
            bottom: '20px',
            height: '24px',
            borderRight: '1px solid #BBBBBB'
          }}
        ></span>
      );
    }
    return null;
  };

  return (
    <div style={{ display: 'flex', width: '100%', maxHeight: '70px' }}>
      {props.list.map((value: TabContentProps, index: number) => {
        const btnCss = props.defaultValue === value.value ? '#FFFFFF' : '#F4F4F4';
        const fontCss = props.defaultValue === value.value ? '#EF8200' : '#BBBBBB';

        return (
          <label
            key={value.value}
            htmlFor={`${index}`}
            style={{
              flex: '1 0 auto',
              position: 'relative',
              textAlign: 'center',
              background: `${btnCss} 0% 0% no-repeat padding-box`
            }}
          >
            <S.TabButton style={{ color: `${fontCss}` }}>
              <input
                id={`${index}`}
                value={value.value}
                onClick={(e: any) => props.onClick(value.value)}
                onChange={() => {}}
                style={{ display: 'none' }}
              />
              {value.title}
            </S.TabButton>
            <Splitter index={index} value={value.value} />
          </label>
        );
      })}
    </div>
  );
};

export default Tabs;
